import React, { useState, useEffect } from 'react';
import InstagramLink from './InstagramLink';

const TRIAL_DAYS = 7;
const TRIAL_MS = TRIAL_DAYS * 24 * 60 * 60 * 1000;

export function calcularRestanteTrial(dateJoined) {
  return new Date(dateJoined).getTime() + TRIAL_MS - Date.now();
}

export function formatearRestanteTrial(ms) {
  const totalMinutos = Math.max(0, Math.floor(ms / 60000));
  const dias = Math.floor(totalMinutos / (60 * 24));
  const horas = Math.floor((totalMinutos % (60 * 24)) / 60);
  const minutos = totalMinutos % 60;
  const partes = [];
  if (dias > 0) partes.push(`${dias}d`);
  if (dias > 0 || horas > 0) partes.push(`${horas}h`);
  partes.push(`${minutos}m`);
  return partes.join(' ');
}

// Solo informativo — el corte real de acceso ya lo hace el backend en
// login y refresh (accounts/token_views.py). Este banner deja de mostrarse
// apenas el conteo llega a cero porque, a partir de ahí, la próxima llamada
// autenticada ya va a rebotar contra el backend.
function TrialBanner({ usuario }) {
  const [, forzarActualizacion] = useState(0);

  useEffect(() => {
    const id = setInterval(() => forzarActualizacion((t) => t + 1), 60000);
    return () => clearInterval(id);
  }, []);

  if (!usuario || usuario.activated_by_admin || !usuario.date_joined) return null;

  const restanteMs = calcularRestanteTrial(usuario.date_joined);
  if (restanteMs <= 0) return null;

  return (
    <div className="trial-banner">
      <span className="trial-banner-contador">
        Período de prueba: quedan {formatearRestanteTrial(restanteMs)}.
      </span>
      <span className="trial-banner-contacto">
        Contáctanos a <InstagramLink /> o al{' '}
        <a
          href="https://wa.me/5493854129182"
          target="_blank"
          rel="noopener noreferrer"
          className="trial-banner-whatsapp"
        >
          3854129182
        </a>{' '}
        para activar tu cuenta sin límite de tiempo
      </span>
    </div>
  );
}

export default TrialBanner;
